import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { Auth } from "aws-amplify";
import { saveReturnPath } from "../utils/postLoginPath";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const signOutUser = async () => {
  try {
    await Auth.signOut();
    localStorage.removeItem("user");
    // Remember where they were so signing back in returns them there
    saveReturnPath(window.location);
    window.location.href = "/login";
  } catch (error) {
    console.error("Error signing out:", error);
  }
};

const isTokenExpired = (token) => {
  if (!token) {
    return true;
  }

  const payload = jwtDecode(token);
  if (!payload || !payload.exp) {
    return true;
  }

  const currentTimestamp = Math.floor(Date.now() / 1000);

  return payload.exp < currentTimestamp;
};

api.interceptors.request.use((config) => {
  // Get fresh token from localStorage on each request
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user ? user.jwt : "";

  if (token) {
    const expired = isTokenExpired(token);
    if (expired) {
      signOutUser();
      return config;
    }
    // Set authorization header with fresh token
    config.headers.Authorization = token;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      signOutUser();
    }

    return Promise.reject(error);
  }
);

export default api;
